<avi-confirmation
    class="clr-wrapper"
    (onClose)="handleCancel()"
    [closeOnBackdropClick]="false"
    [closeOnEscapeKeypress]="true"
    [headerText]="header"
>
    <ng-container ngProjectAs="avi-confirmation_modal-content">
        <div class="disconnect-cloud-licensing-modal__content">
            <p class="disconnect-cloud-licensing-modal__confirmation-message">
                {{ l10nKeys.disconnectConfirmationMessage | vtranslate }}
            </p>
            <div class="disconnect-cloud-licensing-modal__checkbox">
                <clr-checkbox-wrapper>
                    <input
                        type="checkbox"
                        clrCheckbox
                        [(ngModel)]="disconnectFromCloudServices"
                        id="confirm-disconnect-cloud-services"
                    />
                    <label for="confirm-disconnect-cloud-services">
                        {{ l10nKeys.disconnectFromCloudServicesLabel | vtranslate }}
                    </label>
                </clr-checkbox-wrapper>
            </div>
        </div>
    </ng-container>

    <ng-container ngProjectAs="avi-confirmation_modal-actions">
        <cds-button
            id="cancel-button"
            action="outline"
            (click)="handleCancel()"
            (keypress)="handleCancel()"
            (keydown)="handleCancel()"
            (keyup)="handleCancel()"
        >
            {{ l10nKeys.cancelButtonLabel | vtranslate }}
        </cds-button>

        <cds-button
            id="continue-button"
            (click)="handleConfirm()"
            (keypress)="handleConfirm()"
            (keyup)="handleConfirm()"
            (keydown)="handleConfirm()"
            status="danger"
            action="solid"
        >
            {{ l10nKeys.yesContinueButtonLabel | vtranslate }}
        </cds-button>
    </ng-container>
</avi-confirmation>
